var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesigndev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31152 14.4265H3.63415C2.45513 14.4265 1.5 15.3816 1.5 16.5607V36.8659C1.5 38.0449 2.45513 39 3.63415 39H37.2383C38.4173 39 39.3724 38.0449 39.3724 36.8659V16.5607C39.3724 15.3816 38.4173 14.4265 37.2383 14.4265H31.8115",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.422 32.0808H10.7011C10.4623 32.0808 10.2687 32.2744 10.2687 32.5132V35.0653C10.2687 35.3041 10.4623 35.4977 10.7011 35.4977H30.422C30.6608 35.4977 30.8543 35.3041 30.8543 35.0653V32.5132C30.8543 32.2744 30.6608 32.0808 30.422 32.0808Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83518 25.9358H7.24298C7.00419 25.9358 6.81061 26.1294 6.81061 26.3682V28.9604C6.81061 29.1992 7.00419 29.3927 7.24298 29.3927H9.83518C10.074 29.3927 10.2676 29.1992 10.2676 28.9604V26.3682C10.2676 26.1294 10.074 25.9358 9.83518 25.9358Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8464 25.9358H13.2542C13.0154 25.9358 12.8218 26.1294 12.8218 26.3682V28.9604C12.8218 29.1992 13.0154 29.3927 13.2542 29.3927H15.8464C16.0852 29.3927 16.2788 29.1992 16.2788 28.9604V26.3682C16.2788 26.1294 16.0852 25.9358 15.8464 25.9358Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2899 26.5266V28.9606C22.29 29.0174 22.279 29.0736 22.2574 29.126C22.2358 29.1785 22.204 29.2262 22.1639 29.2663C22.1239 29.3065 22.0763 29.3384 22.0239 29.3601C21.9715 29.3818 21.9153 29.393 21.8586 29.393H19.2653C19.1509 29.393 19.0412 29.3476 18.9603 29.2667C18.8794 29.1858 18.834 29.0761 18.834 28.9617V26.5276",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8677 25.9358H25.2755C25.0367 25.9358 24.8431 26.1294 24.8431 26.3682V28.9604C24.8431 29.1992 25.0367 29.3927 25.2755 29.3927H27.8677C28.1065 29.3927 28.3001 29.1992 28.3001 28.9604V26.3682C28.3001 26.1294 28.1065 25.9358 27.8677 25.9358Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8789 25.9358H31.2867C31.0479 25.9358 30.8543 26.1294 30.8543 26.3682V28.9604C30.8543 29.1992 31.0479 29.3927 31.2867 29.3927H33.8789C34.1177 29.3927 34.3113 29.1992 34.3113 28.9604V26.3682C34.3113 26.1294 34.1177 25.9358 33.8789 25.9358Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83518 19.7913H7.24298C7.00419 19.7913 6.81061 19.9848 6.81061 20.2236V22.8158C6.81061 23.0546 7.00419 23.2482 7.24298 23.2482H9.83518C10.074 23.2482 10.2676 23.0546 10.2676 22.8158V20.2236C10.2676 19.9848 10.074 19.7913 9.83518 19.7913Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5575 23.2485H13.2532C13.1965 23.2485 13.1403 23.2373 13.0879 23.2156C13.0355 23.1938 12.9879 23.162 12.9478 23.1218C12.9077 23.0816 12.876 23.034 12.8544 22.9815C12.8328 22.9291 12.8217 22.8729 12.8218 22.8161V21.9175M28.3011 21.9175V22.8161C28.3011 22.8729 28.2899 22.929 28.2682 22.9814C28.2464 23.0338 28.2146 23.0814 28.1744 23.1215C28.1342 23.1616 28.0866 23.1933 28.0341 23.2149C27.9816 23.2365 27.9254 23.2476 27.8687 23.2475H26.5654",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8789 19.7913H31.2867C31.0479 19.7913 30.8543 19.9848 30.8543 20.2236V22.8158C30.8543 23.0546 31.0479 23.2482 31.2867 23.2482H33.8789C34.1177 23.2482 34.3113 23.0546 34.3113 22.8158V20.2236C34.3113 19.9848 34.1177 19.7913 33.8789 19.7913Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9662 19.8746L20.5614 27.8525L10.1577 19.8746C9.89427 19.673 9.68086 19.4134 9.53409 19.116C9.38731 18.8185 9.31113 18.4912 9.31146 18.1595V2.72848C9.31146 1.77335 10.0848 1 11.0399 1H30.083C31.0381 1 31.8114 1.77437 31.8114 2.72848V18.1595C31.8114 18.8311 31.5002 19.4648 30.9662 19.8746Z",
    stroke: "#FF9515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigndev);
export default __webpack_public_path__ + "static/media/Designdev.65b7b5bbf51cc090f4bc28f67daabf35.svg";
export { ForwardRef as ReactComponent };